<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    font-family: "Microsoft YaHei";
    font-weight: normal;
    border: 0;
    outline-style: none;
    text-decoration: none;
    font-style: normal;
    font-size: .24rem;
}

body::-webkit-scrollbar {
    display: none;
}

@font-face {
    font-family: "KaiTi";
    src: url('assets/fonts/KaiTi.ttf');
}

@font-face {
    font-family: "SongTi";
    src: url('assets/fonts/SongTi.ttf');
}

@font-face {
    font-family: "Lishu";
    src: url('assets/fonts/Lishu.ttf');
}
</style>



// WEBPACK FOOTER //
// src/App.vue